export function ValidExpirationDateDirective(paymentService) {
    'ngInject';

    let data = {};

    return {
        restrict: 'A',
        require: 'ngModel',
        link: function($scope, $element, $attrs, $model) {
            Object.assign(data, {
                $scope, $element, $attrs, $model
            });

            $scope.$watch(
                () => $model.$modelValue,
                newValue => {
                    _validate(newValue);
                }
            );
        }
    };

    function _validate(modelValue) {
        const expValid = paymentService.expirationDateValid(modelValue);
        data.$model.$setValidity('inPast', expValid || data.$model.$pristine);
    }
}
